<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="card shadow-sm">
          <div class="card-body p-4">
            <h4 class="card-title text-center mb-4 text-primary">Login</h4>
            <form @submit.prevent="handleLogin">
              <div class="mb-3">
                <label for="email" class="form-label text-secondary">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="email"
                  required
                  aria-label="Email address"
                />
              </div>
              <div class="mb-3">
                <label for="password" class="form-label text-secondary">Password</label>
                <div class="input-group">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    id="password"
                    v-model="password"
                    required
                    aria-label="Password"
                  />
                  <button
                    class="btn btn-outline-primary"
                    type="button"
                    @click="togglePassword"
                    aria-label="Toggle password visibility"
                  >
                    <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                  </button>
                </div>
              </div>
              <div class="d-grid">
                <button
                  type="submit"
                  class="btn btn-primary btn-block"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  <span v-if="!loading">Login</span>
                  <span v-else>Logging in...</span>
                </button>
              </div>
            </form>

            <!-- Success or Error Message -->
            <div v-if="message" class="mt-3" :class="messageClass">
              {{ message }}
            </div>

            <div v-if="$route.query.error" class="alert alert-danger">
      {{ $route.query.error }}
    </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      message: '',
      messageClass: '',
      loading: false, // New loading state
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    // Helper: Wrap geolocation in a Promise
  getCurrentPosition() {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation is not supported by your browser'));
      } else {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        });
      }
    });
  },

  getDevice() {
    const ua = navigator.userAgent;

    if (/Windows/i.test(ua)) return 'Windows';
    if (/Macintosh|Mac OS X/i.test(ua)) return 'Mac';
    if (/iPhone/i.test(ua)) return 'iPhone';
    if (/Android/i.test(ua)) return 'Android';
    if (/Linux/i.test(ua)) return 'Linux';
    return 'Unknown';
  },

  getBrowser() {
    const ua = navigator.userAgent;

    if (ua.indexOf("Firefox") > -1) {
      return "Firefox";
    } else if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR") > -1) {
      return "Opera";
    } else if (ua.indexOf("Trident") > -1) {
      return "Internet Explorer";
    } else if (ua.indexOf("Edge") > -1) {
      return "Edge";
    } else if (ua.indexOf("Chrome") > -1) {
      return "Chrome";
    } else if (ua.indexOf("Safari") > -1) {
      return "Safari";
    } else {
      return "Unknown";
    }
  },


  

    async handleLogin() {
  this.loading = true; // Set loading to true
  this.message = ''; // Clear any previous messages


  // Helper function: get approximate location fallback
  const getApproximateLocation = async () => {
    try {
      // Example with ipapi.co (free, no key required for basic)
      const res = await axios.get('https://ipapi.co/json/');
      const { latitude, longitude } = res.data;
      return {
        latitude: latitude || null,
        longitude: longitude || null,
        accuracy: null
      };
    } catch (err) {
      // If API call fails, fallback to timezone-based guess (very rough)
      // For demo, just return nulls
      return {
        latitude: null,
        longitude: null,
        accuracy: null
      };
    }
  };

  try {
    // const loginTime = new Date().toISOString(); // <-- add this line

    const now = new Date();
const loginTime = now.getFullYear() + '-' +
  String(now.getMonth() + 1).padStart(2, '0') + '-' +
  String(now.getDate()).padStart(2, '0') + ' ' +
  String(now.getHours()).padStart(2, '0') + ':' +
  String(now.getMinutes()).padStart(2, '0') + ':' +
  String(now.getSeconds()).padStart(2, '0');

    // 2. Get live GPS location
    // const position = await this.getCurrentPosition(); // This returns a Promise
    // const latitude = position.coords.latitude;
    // const longitude = position.coords.longitude;
    // const accuracy = position.coords.accuracy;


     let latitude, longitude, accuracy;

    try {
      // Try to get precise location
      const position = await this.getCurrentPosition();
      latitude = position.coords.latitude;
      longitude = position.coords.longitude;
      accuracy = position.coords.accuracy;
    } catch (geoError) {
      // User denied or error, fallback to approximate location
      const approx = await getApproximateLocation();
      latitude = approx.latitude;
      longitude = approx.longitude;
      accuracy = approx.accuracy;
    }

    const device = this.getDevice();
    const browser = this.getBrowser(); // newly added browser detection

      // NOTE: You cannot get IP address reliably on frontend without external service.
      // So you send null or empty, and your backend should get IP from request

    const response = await axios.post('/userlogin', {
      email: this.email,
      password: this.password,
      login_time: loginTime, // <-- send login_time
      latitude: latitude,
      longitude: longitude,
      accuracy: accuracy,
      device: device,
      browser: browser,
    });

    if (response && response.data) {
      const { token, firstName, profile_photo_url, role, id, teacher_id, institute_id,  theme_color } = response.data;

      // Store common values in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('firstName', firstName);
      localStorage.setItem('profile_photo_url', profile_photo_url);
      localStorage.setItem('role', role);
      localStorage.setItem('id', id);
      localStorage.setItem('themeMode', theme_color); 
      

      // Store role-specific values in localStorage
      if (role === 1) {
        localStorage.setItem('teacher_id', teacher_id);
      } else if (role === 2) {
        localStorage.setItem('institute_id', institute_id);
      }

      this.message = 'Login successful!';
      this.messageClass = 'text-success';

      // Navigate based on role
      if (role === 1) {
        // this.$router.push('/teacherHome');
        this.$router.push({ path: "/teacherHome", query: { currentPage: "home" } });
      } else if (role === 2) {
        // this.$router.push('/instituteHome');
        this.$router.push({ path: "/instituteHome", query: { currentPage: "home" } });
      } else {
        this.message = 'Unauthorized role!';
        this.messageClass = 'text-danger';
      }
    } else {
      this.message = 'Unexpected response structure';
      this.messageClass = 'text-danger';
    }
  } catch (error) {
    console.error('Login error:', error);

    if (error.response) {
      this.message = 'Login failed: ' + (error.response.data.message || 'Unknown error');
    } else if (error.request) {
      this.message = 'Login failed: No response from server';
    } else {
      this.message = 'Login failed: ' + error.message;
    }

    this.messageClass = 'text-danger';
  } finally {
    this.loading = false; // Reset loading state
  }
},

  },

  mounted() {
  const errorQuery = this.$route.query.error;
  if (errorQuery === 'unauthorized') {
    this.message = 'You have been logged out or your session expired.';
    this.messageClass = 'text-danger';
  }
}

};
</script>

<style scoped>
.container {
  max-width: 400px;
}

.card {
  border: none;
  border-radius: 10px;
}

.card-body {
  background-color: #f8f9fa;
}

.card-title {
  font-weight: bold;
}

.form-label {
  font-weight: 600;
}

.input-group .btn-outline-primary {
  border-radius: 0 5px 5px 0;
  border-width: 1px;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #004085;
}

.btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.text-success {
  color: green;
}

.text-danger {
  color: red;
}

.spinner-border {
  vertical-align: middle;
}
</style>
